import { apiCallPost } from "../api";
import { apiPaths } from "../config/apiPaths";

export const updateWhatsappProfileApi = async (payload = {}, authHeaders = {}) => {
    try {
        const {
            companyId,
            phoneNumberId,
            displayName,
            imageUrl,
            description,
            address,
            email,
            category,
            websites
        } = payload;

        const apiPayload = {
            operation: 'UPDATEPROFILE',
            payload: {
                companyId,
                phoneNumberId,
                ...(displayName !== undefined && { displayName }),
                ...(imageUrl !== undefined && { imageUrl }),
                ...(description !== undefined && { description }),
                ...(address !== undefined && { address }),
                ...(email !== undefined && { email }),
                ...(category !== undefined && { category }),
                ...(websites !== undefined && { websites })
            }
        };

        const res = await apiCallPost(apiPaths.whatsappChannel, apiPayload, authHeaders);

        if (res && typeof res === 'object' && res.success === true) {
            return { data: res.result || {}, status: true, msg: 'Profile updated successfully' };
        }

        return {
            data: {},
            status: false,
            errMsg: res?.errMsg || res?.message || 'Failed to update WhatsApp profile'
        };
    } catch (err) {
        return {
            status: false,
            errMsg: err.message || 'An error occurred while updating profile'
        };
    }
};

export const getPhoneProfileApi = async (payload = {}, authHeaders = {}) => {
    try {
        const { companyId, phoneNumberId } = payload;

        const apiPayload = {
            operation: 'GETPHONEPROFILE',
            payload: {
                companyId,
                phoneNumberId
            }
        };

        const res = await apiCallPost(apiPaths.whatsappChannel, apiPayload, authHeaders);

        if (res && typeof res === 'object' && res.success === true) {
            return { data: res.result?.profile || {}, status: true, msg: 'Phone profile loaded successfully' };
        }

        return {
            data: {},
            status: false,
            errMsg: res?.errMsg || res?.message || 'Failed to load phone profile'
        };
    } catch (err) {
        return {
            status: false,
            errMsg: err.message || 'An error occurred while loading phone profile'
        };
    }
};

export const getCategoriesApi = async (payload = {}, authHeaders = {}, params = {}) => {
    try {
        const apiPayload = {
            operation: 'GETCATEGORIES'
        };

        const res = await apiCallPost(apiPaths.whatsappChannel, apiPayload, authHeaders);

        if (res && typeof res === 'object' && res.success === true) {
            return { 
                data: res.result?.categories || [], 
                status: true, 
                msg: 'Categories loaded successfully' 
            };
        }

        return {
            data: [],
            status: false,
            errMsg: res?.errMsg || res?.message || 'Failed to load categories'
        };
    } catch (err) {
        return {
            status: false,
            errMsg: err.message || 'An error occurred while loading categories',
            data: []
        };
    }
};